import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/Terms/Terms.js");
